export default "__VITE_ASSET__DZylnXvy__"